import fetch from 'lib/fetch'
import { useQuery } from '@tanstack/react-query'
import { StoreCategory } from 'src/types/storeCategory'

export const storeCatalogCategoryKey = (slug: string) => [
  'storeCatalogCategory',
  slug,
]

const showPath = (categorySlug: string) =>
  `/store/api/categories/${categorySlug}`
export const CATEGORY_STALE_TIME = 600000

const fetchCategory = (categorySlug: string): Promise<StoreCategory> =>
  fetch(showPath(categorySlug))

export const useShow = (categorySlug: string) =>
  useQuery({
    queryKey: storeCatalogCategoryKey(categorySlug),
    queryFn: () => fetchCategory(categorySlug),
    staleTime: CATEGORY_STALE_TIME,
  })

export const CategoriesAPI = {
  useShow,
}
